import type { PaigeClient } from '@paige/api-client';
import type { AppearanceApi } from './data-source';
import { unwrap } from './http';

/**
 * The person's look of Paige (`/me/appearance`): read and replaced whole. It names no company, so a staff member
 * in a customer's read-only view keeps their own colour without a write to that company.
 */
export function appearanceApi(client: PaigeClient): AppearanceApi {
  return {
    async get() {
      return unwrap(await client.GET('/me/appearance'));
    },
    async save(appearance) {
      return unwrap(await client.PUT('/me/appearance', { body: appearance }));
    },
  };
}
